// src/pages/Exams/generate/hooks/useJobHistory.ts
import { useQuery } from '@tanstack/react-query';
import { ExamGenApi } from '../client';

export const HISTORY_LIMIT = 25;

export function useJobHistory(limit = HISTORY_LIMIT) {
  return useQuery({
    queryKey: ['exam_gen', 'history', limit],
    queryFn: () => ExamGenApi.listHistory({ limit }),
  });
}
